import styled from '@emotion/styled'

import { Button } from '@/components/Button'
import { HeadingM } from '@/components/Typography'
import { CONFIG } from '@/styles/emotion.config'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  min-height: 29.5rem;
  max-width: 58rem;
  width: 100%;
  background-color: rgba(var(--theme-white));

  border: 1px solid rgb(var(--theme-surface-silver));
  border-radius: 0.75rem;
`

export const Header = styled.div`
  width: 100%;
`
export const Body = styled.div`
  padding: 1.5rem;
  min-height: 29.25rem;
`

export const Divider = styled.hr`
  box-shadow: ${CONFIG.theme.shadows.divider};
`

export const Heading = styled(HeadingM)`
  padding: 1rem 0;
  text-align: center;
`

export const Cta = styled(Button)`
  width: 17rem;
  height: 3rem;
  ${CONFIG.media.mobileMd} {
    width: 100%;
  }
`

export const ButtonsWrapper = styled.div`
  margin-top: 1.5rem;
  width: 100%;
  gap: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
`
